import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const menu = {
  namespaced: true,
  state: {
    currentPage: '',
    currentMode: '',
    currentActiveMenu: null,
    menu: [],
    suspendedMenu: []
  },
  getters,
  mutations,
  actions
};
